// extracted by mini-css-extract-plugin
module.exports = {"upgradeCard":"styles_upgradeCard__36yth"};